import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { Box, Flex } from '@chakra-ui/react';
import Media from '@components/atoms/Media';
import { useSeoMeta } from '../../hooks/useSeoMeta';

const Logo = ({ linkTo = null, ...props }) => {
  const { siteSettings } = useStaticQuery(graphql`
    {
      siteSettings: strapiSiteSettings {
        logoText
        logo {
          localFile {
            childImageSharp {
              gatsbyImageData(
                formats: [AUTO, WEBP, AVIF]
                placeholder: NONE
                quality: 70
              )
            }
          }
        }
      }
    }
  `);

  const {
    site: {
      siteMetadata: { title: siteTitle, language }
    }
  } = useSeoMeta();

  return (
    <Flex
      justifyContent={{ base: `center`, lg: `left` }}
      width={{ base: `100%`, lg: `auto` }}>
      <Box
        py={{ base: `1.191rem`, md: `2rem` }}
        pl={{ base: `0`, lg: `0` }}
        ml={{ base: `0`, sm: `0` }}
        maxWidth="13.875rem"
        {...props}>
        {siteSettings.logo &&
          (linkTo !== null ? (
            <Link
              to={linkTo}
              aria-label={siteSettings.logoText}
              title={siteSettings.logoText}
              hrefLang={language.toLowerCase()}
              role="link">
              <Media media={siteSettings.logo} alt={siteTitle} />
            </Link>
          ) : (
            <Media media={siteSettings.logo} alt={siteTitle} />
          ))}
      </Box>
    </Flex>
  );
};

export default Logo;
